<template>
  <v-container
    fluid
    v-if="checkEvent.success && checkAuthReceptionist.isAuthenticated"
  >
    <Header />

    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
  </v-container>

  <v-container fluid v-else-if="checkEvent.success == false">
    <EventNotFound />
  </v-container>
  <v-container fluid v-else>
    <Loading />
  </v-container>
</template>

<script>
import Header from '@/components/receptionist/Header';
// import ScrollTopBtn from "../components/ScrollTopBtn";
import EventNotFound from '@/containers/Errors/EventNotFound';
import Loading from '@/containers/Errors/Loading';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    transitionName: 'slide-left'
  }),
  components: {
    Header,
    // ScrollTopBtn,
    EventNotFound,
    Loading
  },
  watch: {
    checkEvent: function (val) {
      return val;
    },

    checkAuthReceptionist: function (val, oldVal) {
      if (val.isUnauthorized === true) {
        this.$notify({
          group: 'foo',
          type: 'warning',
          title: 'Message',
          text: this.$t('general.session-exprired', {
            split: '/'
          })
        });
        this.$router.push({ name: 'receptionist-login' });
      }

      return val;
    }
  },

  computed: {
    ...mapGetters({
      checkAuthReceptionist: 'getStatusCheckAuthReceptionist'
    })
  },

  methods: {}
};
</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.2s ease-in-out;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
